import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import UserDropdown from '../Dropdowns/UserDropdown';
import UserInfoContext from '../UserInfo/UserInfoContext';
import NotificationDropdown from '../Dropdowns/NotificationDropdown';

export default function Sidebar() {
  const { data: user } = useContext(UserInfoContext);
  const [collapseShow, setCollapseShow] = React.useState('hidden');

  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-no-wrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-no-wrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow('bg-white m-2 py-3 px-6')}
          >
            <i className="fas fa-bars" />
          </button>
          {/* Brand */}
          <Link
            className="md:block text-left md:pb-2 text-gray-700 mr-0 inline-block whitespace-no-wrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <img src="/static/icons/logo-sofiatech.webP" width="150px" alt="" />
          </Link>
          {/* User */}
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={`md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded ${collapseShow}`}
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-gray-300">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-gray-700 mr-0 inline-block whitespace-no-wrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    3D Store
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow('hidden')}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
            {/* Form */}
            <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="px-3 py-2 h-12 border border-solid  border-gray-600 placeholder-gray-400 text-gray-700 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
            </form>

            {/* Divider */}
            <hr className="my-4 md:min-w-full" />
            {/* Heading */}
            <h6 className="md:min-w-full text-gray-600 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              Layout Pages
            </h6>
            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={`text-xs uppercase py-3 font-bold block ${
                    window.location.href.indexOf('/3d-dashboard') !== -1
                      ? 'text-blue-500 hover:text-blue-600'
                      : 'text-gray-800 hover:text-gray-600'
                  }`}
                  to="/3d-dashboard"
                >
                  <i
                    className={`fas fa-store mr-2 text-sm ${
                      window.location.href.indexOf('/3d-dashboard') !== -1
                        ? 'opacity-75'
                        : 'text-gray-400'
                    }`}
                  />{' '}
                  3D Store
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={`text-xs uppercase py-3 font-bold block ${
                    window.location.href.indexOf('/dashboard') !== -1
                      ? 'text-blue-500 hover:text-blue-600'
                      : 'text-gray-800 hover:text-gray-600'
                  }`}
                  to="/dashboard"
                >
                  <i
                    className={`fas fa-tv mr-2 text-sm ${
                      window.location.href.indexOf('/dashboard') !== -1
                        ? 'opacity-75'
                        : 'text-gray-400'
                    }`}
                  />{' '}
                  Dashboard
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={`text-xs uppercase py-3 font-bold block ${
                    window.location.href.indexOf('/devices') !== -1
                      ? 'text-blue-500 hover:text-blue-600'
                      : 'text-gray-800 hover:text-gray-600'
                  }`}
                  to="/devices"
                >
                  <i
                    className={`fas fa-table mr-2 text-sm ${
                      window.location.href.indexOf('/devices') !== -1
                        ? 'opacity-75'
                        : 'text-gray-400'
                    }`}
                  />{' '}
                  Device Profiles
                </Link>
              </li>

              {user?.currentPerson.is_admin && (
                <>
                  <li className="items-center">
                    <Link
                      className={`text-xs uppercase py-3 font-bold block ${
                        window.location.href.indexOf('/device-positions') !== -1
                          ? 'text-blue-500 hover:text-blue-600'
                          : 'text-gray-800 hover:text-gray-600'
                      }`}
                      to="/device-positions"
                    >
                      <i
                        className={`fas fa-map mr-2 text-sm ${
                          window.location.href.indexOf('/device-positions') !==
                          -1
                            ? 'opacity-75'
                            : 'text-gray-400'
                        }`}
                      />{' '}
                      Device Positions
                    </Link>
                  </li>
                  <li className="items-center">
                    <Link
                      className={`text-xs uppercase py-3 font-bold block ${
                        window.location.href.indexOf('/users') !== -1
                          ? 'text-blue-500 hover:text-blue-600'
                          : 'text-gray-800 hover:text-gray-600'
                      }`}
                      to="/users"
                    >
                      <i
                        className={`fas fa-users mr-2 text-sm ${
                          window.location.href.indexOf('/users') !== -1
                            ? 'opacity-75'
                            : 'text-gray-400'
                        }`}
                      />{' '}
                      All Users
                    </Link>
                  </li>
                </>
              )}

              <li className="items-center">
                <Link
                  className={`text-xs uppercase py-3 font-bold block ${
                    window.location.href.indexOf('/settings') !== -1
                      ? 'text-blue-500 hover:text-blue-600'
                      : 'text-gray-800 hover:text-gray-600'
                  }`}
                  to="/settings"
                >
                  <i
                    className={`fas fa-tools mr-2 text-sm ${
                      window.location.href.indexOf('/settings') !== -1
                        ? 'opacity-75'
                        : 'text-gray-400'
                    }`}
                  />{' '}
                  Settings
                </Link>
              </li>
            </ul>

            {/* Divider */}
            <hr className="my-4 md:min-w-full" />
            {/* Heading */}
            <h6 className="md:min-w-full text-gray-600 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              Other Pages
            </h6>
            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
              <li className="items-center">
                <Link
                  className={`text-xs uppercase py-3 font-bold block ${
                    window.location.href.indexOf('/notifications') !== -1
                      ? 'text-blue-500 hover:text-blue-600'
                      : 'text-gray-800 hover:text-gray-600'
                  }`}
                  to="/notifications"
                >
                  <i
                    className={`fas fa-bell mr-2 text-sm ${
                      window.location.href.indexOf('/notifications') !== -1
                        ? 'opacity-75'
                        : 'text-gray-400'
                    }`}
                  />{' '}
                  Notifications List
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className="text-gray-800 hover:text-gray-600 text-xs uppercase py-3 font-bold block"
                  to="/"
                >
                  <i className="fas fa-newspaper text-gray-500 mr-2 text-sm" />{' '}
                  Landing Page
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
